import {Action} from '@ngrx/store';
import {Activity, ActivitySubjectTypes} from '@app/core/models/activity.model';
import {Pagination} from '@app/core/models/pagination.model';

export enum EActivityActions {
	GetActivities = '[Activity] Get Activities',
	GetActivitiesSuccess = '[Activity] Get Activities Success',
	GetActivity = '[Activity] Get Activity',
	GetActivitySuccess = '[Activity] Get Activity Success',
	GetRelationActivity = '[Activity] Get Relation Activity',
	GetRelationActivitySuccess = '[Activity] Get Relation Activity Success',
	SetActivities = '[Activity] Set Activities',
}

export class GetActivities implements Action {
	public readonly type = EActivityActions.GetActivities;

	constructor(public departmentId: number, public subjectType?: ActivitySubjectTypes, public subjectId?: number) {
	}
}

export class GetActivitiesSuccess implements Action {
	public readonly type = EActivityActions.GetActivitiesSuccess;

	constructor(public activities: Activity[], public pagination: Pagination) {
	}
}

export class GetActivity implements Action {
	public readonly type = EActivityActions.GetActivity;

	constructor(public departmentId: number, public activityId: number) {
	}
}

export class GetActivitySuccess implements Action {
	public readonly type = EActivityActions.GetActivitySuccess;

	constructor(public activity: Activity) {
	}
}

export class GetRelationActivity implements Action {
	public readonly type = EActivityActions.GetRelationActivity;

	constructor(public departmentId: number, public model: ActivitySubjectTypes, public model_id: number, public relation: 'shiftStock' | 'shiftStockBids') {
	}
}

export class GetRelationActivitySuccess implements Action {
	public readonly type = EActivityActions.GetRelationActivitySuccess;

	constructor(public activities: Activity[], public pagination: Pagination) {
	}
}

export class SetActivities implements Action {
	public readonly type = EActivityActions.SetActivities;

	constructor(public activities: Activity[]) {
	}
}

export type ActivityActions =
	GetActivities |
	GetActivitiesSuccess |
	GetActivity |
	GetActivitySuccess |
	GetRelationActivity |
	GetRelationActivitySuccess |
	SetActivities
	;
